const isRocket = process.env.CPA_ENV === 'rocket';

export default !isRocket ? [
	{
		href: '/programs/list',
		name: 'List',
		permission: null
	},
	{
		href: '/programs/stopped-list',
		name: 'Stopped list',
		permission: null
	},
	{
		href: '/programs/additional-list',
		name: 'Additional list',
		permission: null
	},
	{
		href: '/programs/locations-plan',
		name: 'Locations plan',
		permission: null
	}
] : [
	{
		href: '/programs/list',
		name: 'List',
		permission: null
	},
	{
		href: '/programs/additional-list',
		name: 'Additional list',
		permission: null
	},
	{
		href: '/programs/categories',
		name: 'Categories',
		permission: null
	}
];


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/tabs.js